<!--  -->
<template>
  <div>
    <div class="header">
      <el-form inline>
        <el-form-item label="状态：">
          <el-select v-model="form.status" placeholder="请选状态">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              clearable="true"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词：">
          <el-input v-model="form.keyword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="screening">筛选</el-button>
          <el-button type="primary" @click="dialogSelectReleaseChannel = true">
            新建列表页
          </el-button>
          <el-dialog
            class="dialog-select-release-channel"
            title="选择发布渠道"
            :visible.sync="dialogSelectReleaseChannel"
            width="30%"
          >
            <el-divider class="dialog-divider"></el-divider>
            <div class="select-form-item radio-container">
              <el-radio v-model="selectReleaseChannel" label="公众号">公众号</el-radio>
              <el-radio v-model="selectReleaseChannel" label="企业微信">企业微信</el-radio>
            </div>
            <div class="select-form-item select-container">
              <el-select
                v-show="selectReleaseChannel === '公众号'"
                v-model="selectedPublicId"
                placeholder="请选择公众号"
              >
                <el-option
                  v-for="item in applist"
                  :key="item.app_name"
                  :label="item.app_name"
                  :value="item.id"
                  :disabled="item.status === 2"
                ></el-option>
              </el-select>
              <el-select
                v-show="selectReleaseChannel === '企业微信'"
                v-model="selectedWechatId"
                placeholder="请选择企业微信应用"
              >
                <el-option
                  v-for="item in wxList"
                  :key="item.app_name"
                  :label="item.app_name"
                  :value="item.id"
                  :disabled="item.status === 2"
                ></el-option>
              </el-select>
            </div>
            <el-divider class="dialog-divider"></el-divider>
            <div class="select-form-item button-container">
              <el-button class="dialog-button" plain @click="dialogSelectReleaseChannel = false">
                取消
              </el-button>
              <el-button class="dialog-button" plain @click="addArtilce">下一步</el-button>
            </div>
          </el-dialog>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table :data="tableData" v-loading="tableLoading" :row-class-name="tableRowClassName">
        <el-table-column prop="name" label="列表页名称"></el-table-column>
        <el-table-column label="列表页状态">
          <template slot-scope="scope">
            {{ scope.row.status | handleStatus() }}
          </template>
        </el-table-column>
        <el-table-column label="查看权限">
          <template slot-scope="scope">
            {{ scope.row.ListPermission | handlePermission() }}
          </template>
        </el-table-column>
        <el-table-column label="发送渠道" prop="Channel.Name"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="hanldeH5Preview(scope.row.ah5_id)"
              style="font-size: 16px"
              v-if="scope.row.status === 1 || scope.row.status === 2"
            >
              预览
            </el-button>
            <el-button
              type="text"
              @click="handleEdit(scope.row.ah5_id)"
              style="font-size: 16px"
              v-if="scope.row.status === 1 || scope.row.status === 2"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              @click="handleRelease(scope.row.ah5_id)"
              style="font-size: 16px"
              v-if="scope.row.status === 1"
            >
              发布
            </el-button>
            <el-button
              type="text"
              @click="handleDisable(scope.row)"
              style="font-size: 16px"
              v-if="scope.row.status === 2"
            >
              禁用
            </el-button>
            <el-button
              type="text"
              @click="handleRestore(scope.row)"
              style="font-size: 16px"
              v-if="scope.row.status === 3"
            >
              恢复
            </el-button>
            <el-button @click="copyLink(scope.row, 3)" type="text" style="font-size: 16px">
              复制链接
            </el-button>
            <!--            <Clipboard-->
            <!--              :copytext="`${protocol}//${url}/pages/article/active/index?id=${scope.row.ah5_id}`"-->
            <!--            >-->
            <!--              <el-button v-if="scope.row.status === 2" type="text" style="font-size: 16px">-->
            <!--                复制链接-->
            <!--              </el-button>-->
            <!--            </Clipboard>-->
          </template>
        </el-table-column>
      </el-table>
      <Clipboard :copytext="copylink"><span ref="clickClipBoard"></span></Clipboard>
      <div style="margin-top: 20px; float: right">
        <el-pagination
          style="background-color: #ffffff"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-sizes="g_pageSizesConfig"
          :page-size="page_size"
          :current-page="page_index"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <div v-if="h5PreviewVisible">
      <el-dialog :visible.sync="h5PreviewVisible" width="450px" top="10vh" center>
        <iframe
          :src="h5Preview"
          frameborder="0"
          width="400"
          height="700"
          style="margin: 0 auto; display: block"
        ></iframe>
        <span slot="footer" class="dialog-footer">
          <el-button @click="h5PreviewVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { GetArticleH5List, UpdArticleH5Status, GetLinkAddress } from '@/api/artilceList.js';
import Clipboard from '@/components/Clipboard';
import { awaitInterfaceResponse, getMobileDomain } from '@/utils/util';
import { mapGetters } from 'vuex';
import { getAppListApi } from '@/api/setUser';
export default {
  components: {
    Clipboard,
  },
  filters: {
    handleStatus(val) {
      if (val === 1) {
        return '未发布';
      }
      if (val === 2) {
        return '已发布';
      }
      if (val === 3) {
        return '禁用';
      }
    },
    handlePermission(ListPermission = {}) {
      switch (ListPermission.Permission) {
        case 1:
          return '公开';
        case 2:
          return '关注公众号';
        case 3:
          return '注册用户';
        case 4:
          return '企业内部';
        case 5:
          return '企业内部';
        case 6:
          return '根据策略';
        case 7:
          return '企业内部';
        case 8:
          return '企业内部';
        case 9:
          return '企业内部';
        default:
          return '未知';
      }
    },
  },
  data() {
    return {
      channelAppId: '',
      h5Preview: '',
      h5PreviewVisible: false,
      url: getMobileDomain(),
      protocol: location.protocol,
      id: '',
      tableLoading: false,
      form: {
        status: 0,
        keyword: '',
      },
      page_index: 1,
      page_size: this.g_pageSizeDefault,
      total: 0,
      tableData: [],
      statusOptions: [
        // 状态选择项
        {
          label: '全部',
          value: 0,
        },
        {
          label: '未发布',
          value: 1,
        },
        {
          label: '已发布',
          value: 2,
        },
        {
          label: '禁用',
          value: 3,
        },
      ],

      dialogSelectReleaseChannel: false,
      selectReleaseChannel: '公众号',
      publicList: [
        {
          app_name: 'mock公众号1',
          status: 1,
          id: 123,
        },
        {
          app_name: 'mock公众号2',
          status: 2,
          id: 124,
        },
      ],
      selectedChannelId: '',
      selectedPublicId: '',
      selectedWechatId: '',
      selectedChannelName: '',
      copylink: '', // 用于复制链接
    };
  },
  computed: {
    ...mapGetters('user', {
      enterpriseId: 'getEnterpriseId',
    }),
    applist() {
      return this.$store.state.user.managerLogin.app_list.map((item) => ({
        app_name: item.app_name,
        id: item.app_id,
        type: item.type,
        status: Number(item.status),
      }));
    },
    wxList() {
      return this.$store.state.user.managerLogin.agent_list.map((item) => ({
        app_name: item.agent_name,
        id: item.agent_id,
        status: 1,
      }));
    },
  },
  created() {
    this.page_size = this.g_pageSizeDefault;
    this.getList();
    this.getPublicSet();
  },
  methods: {
    hanldeH5Preview(id) {
      this.h5Preview = `${this.protocol}//${this.url}/pages/article/active/index?id=${id}`;
      // this.h5Preview = `https://v2testh5.tsepcn.com/pages/article/active/index?id=${id}`;
      this.h5PreviewVisible = true;
    },
    screening() {
      this.page_index = 1;
      this.getList();
    },
    copyLink(row, type) {
      GetLinkAddress({
        type,
        key: row.ah5_id,
      }).then((res) => {
        if (res.url !== '') {
          this.copylink = res.url;
          this.$refs.clickClipBoard.click();
        } else {
          this.$message.error('暂无链接');
        }
      });
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getList();
    },
    tableRowClassName(row) {
      if (row.row.status === 3) {
        return 'warning-row';
      }
    },
    getList() {
      this.tableLoading = true;
      const req = {
        status: this.form.status,
        keyword: this.form.keyword,
        page_index: this.page_index,
        page_size: this.page_size,
      };
      GetArticleH5List(req)
        .then((res) => {
          this.tableData = res.ah5_list;
          this.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    handleEdit(val) {
      // 编辑
      this.g_tourl(`/saas/artilceList/addArtilce.html?type=edit&ah5_id=${val}`);
    },
    handleRelease(id) {
      UpdArticleH5Status({
        ah5_id: id,
        status: 2,
      })
        .then(() => {
          this.$message.success('发布成功！');
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    handleDisable(row) {
      // 禁用
      this.$confirm('确认禁用吗？', '提示')
        .then(() => {
          UpdArticleH5Status({ ah5_id: row.ah5_id, status: 3 })
            .then(() => {
              this.$message.success('禁用成功');
              this.getList();
            })
            .catch(() => {
              this.$message.error('禁用失败');
            });
        })
        .catch(() => {});
    },
    handleRestore(row) {
      // 恢复
      UpdArticleH5Status({ ah5_id: row.ah5_id, status: 2 })
        .then(() => {
          this.$message.success('恢复成功');
          this.getList();
        })
        .catch(() => {
          this.$message.error('恢复失败');
        });
    },
    // findChannelName(id) {
    //   const list = this.selectReleaseChannel === '公众号' ? this.publicList : this.wxList;
    //   // const idName = this.selectReleaseChannel === '公众号' ? 'app_id' : 'id';
    //   for (const item of list) {
    //     if (item.id === id) {
    //       this.channelAppId = item.app_id || '';
    //       return item.app_name;
    //     }
    //   }
    //   return '';
    // },
    addArtilce() {
      console.log(this.selectReleaseChannel);
      this.selectedChannelName = '';
      let channelPublicType = 1;
      if (this.selectReleaseChannel === '公众号') {
        const list = this.applist;
        for (const item of list) {
          if (item.id === this.selectedPublicId) {
            this.channelAppId = item.id || '';
            this.selectedChannelName = item.app_name;
            channelPublicType = item.type; // 订阅号/服务号判断
            break;
          }
        }
      } else if (this.selectReleaseChannel === '企业微信') {
        const list = this.wxList;
        for (const item of list) {
          if (item.id === this.selectedWechatId) {
            this.selectedChannelName = item.app_name;
            break;
          }
        }
      }

      // return '';
      // this.selectedChannelName = this.findChannelName(this.selectedChannelId);
      if (this.selectedChannelName) {
        this.g_tourl(
          `/saas/artilceList/addArtilce.html?type=add&channelType=${this.selectReleaseChannel}&channelName=${this.selectedChannelName}&channelId=${this.selectedWechatId}&channelAppId=${this.channelAppId}&channelPublicType=${channelPublicType}`,
        );
      } else {
        this.$message.warning('请选择一个发布渠道');
      }
    },
    getPublicSet() {
      awaitInterfaceResponse('enterpriseId', this)
        .then(() => {
          console.log(this.enterpriseId);
          getAppListApi({
            enterprise_id: this.enterpriseId,
            page_index: 1,
            page_size: 999,
          })
            .then((res) => {
              this.$nextTick(() => {
                this.publicList = res.list;
              });
            })
            .catch((err) => {
              console.error(err);
              this.$message.error('查询发布渠道失败');
            });
        })
        .catch(() => {
          this.$message.error('无法找到enterpriseId');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.el-table .warning-row {
  color: #c0c4cc;
}
.header {
  display: flex;
  align-items: center;
  height: 80px;
  border-bottom: 1px solid rgb(241, 241, 241);
}
.table-list {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  ::v-deep .el-table__header-wrapper .el-table__header {
    color: #303133;
    background: rgba(216, 216, 216, 0.1);
  }
  ::v-deep .el-table .cell {
    font-size: 16px;
  }
  ::v-deep .el-table__empty-text {
    line-height: 0;
  }
}
.dialog-select-release-channel {
  .select-form-item {
    width: 230px;
    display: flex;
    justify-content: space-between;
  }
  .radio-container {
    margin: 20px auto;
  }
  .select-container {
    margin: 40px auto;
  }
  .button-container {
    margin: 0 auto;
    .dialog-button {
      width: 100px;
    }
  }
  .dialog-divider {
    margin-top: 0;
  }
}
</style>
